// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-modal {
  background: #fff;
  padding: 24px 30px;
  border-radius: 14px;
  width: 320px;
  text-align: center;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease;
}
.delete-modal h3 {
  margin-bottom: 12px;
  color: #dc2626;
  font-weight: 600;
}
.delete-modal p {
  font-size: 15px;
  color: #444;
}

.delete-modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.delete-modal-actions .confirm-btn,
.delete-modal-actions .cancel-btn {
  flex: 1 1;
  padding: 10px;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 5px;
  transition: 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.delete-modal-actions .confirm-btn:disabled,
.delete-modal-actions .cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.delete-modal-actions .confirm-btn {
  background-color: #ef4444;
  color: white;
}
.delete-modal-actions .confirm-btn:hover:not(:disabled) {
  background-color: #dc2626;
}
.delete-modal-actions .confirm-btn.deleting {
  background-color: #dc2626;
}
.delete-modal-actions .confirm-btn.deleting .spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.delete-modal-actions .cancel-btn {
  background-color: #e5e7eb;
  color: #333;
}
.delete-modal-actions .cancel-btn:hover:not(:disabled) {
  background-color: #d1d5db;
}
.delete-modal-actions .cancel-btn:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DeleteConfirmationModal/DeleteConfirmationModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,2BAAA;AACF;AACE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,WAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AADF;AAGE;;EAEE,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AADJ;AAGI;;EACE,mBAAA;EACA,YAAA;AAAN;AAIE;EACE,yBAAA;EACA,YAAA;AAFJ;AAII;EACE,yBAAA;AAFN;AAKI;EACE,yBAAA;AAHN;AAKM;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,2BAAA;EACA,kBAAA;EACA,kCAAA;AAHR;AAQE;EACE,yBAAA;EACA,WAAA;AANJ;AAQI;EACE,yBAAA;AANN;AASI;EACE,yBAAA;EACA,cAAA;AAPN;;AAYA;EACE;IAAK,uBAAA;EARL;EASA;IAAO,yBAAA;EANP;AACF;AAQA;EACE;IACE,UAAA;IACA,qBAAA;EANF;EAQA;IACE,UAAA;IACA,mBAAA;EANF;AACF","sourcesContent":[".delete-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.delete-modal {\n  background: #fff;\n  padding: 24px 30px;\n  border-radius: 14px;\n  width: 320px;\n  text-align: center;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.3s ease;\n\n  h3 {\n    margin-bottom: 12px;\n    color: #dc2626;\n    font-weight: 600;\n  }\n\n  p {\n    font-size: 15px;\n    color: #444;\n  }\n}\n\n.delete-modal-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n\n  .confirm-btn,\n  .cancel-btn {\n    flex: 1;\n    padding: 10px;\n    font-size: 14px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    margin: 0 5px;\n    transition: 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n\n  .confirm-btn {\n    background-color: #ef4444;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background-color: #dc2626;\n    }\n\n    &.deleting {\n      background-color: #dc2626;\n      \n      .spinner {\n        width: 16px;\n        height: 16px;\n        border: 2px solid rgba(255, 255, 255, 0.3);\n        border-top: 2px solid white;\n        border-radius: 50%;\n        animation: spin 1s linear infinite;\n      }\n    }\n  }\n\n  .cancel-btn {\n    background-color: #e5e7eb;\n    color: #333;\n\n    &:hover:not(:disabled) {\n      background-color: #d1d5db;\n    }\n\n    &:disabled {\n      background-color: #f3f4f6;\n      color: #9ca3af;\n    }\n  }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
